// extracted by mini-css-extract-plugin
module.exports = {"stagger":"staticSectionStyles_stagger__cnMNP"};